import api from "../../api";
import React, { useState } from "react";
import ConfirmationDialog from "../../components/ConfirmationDialog";

const ZapierTokenDialog = ({ isVisible, onClose, integration }) => {
  const [token, setToken] = useState(integration?.credentials?.zapier_token);
  const [loading, setLoading] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(token || "");
  };

  const generateToken = async (regenerate = false) => {
    if (regenerate) {
      const confirmed = window.confirm(
        "Are you sure you want to regenerate the token? This will invalidate the previous one."
      );
      if (!confirmed) return;
    }

    try {
      setLoading(true);
      const { data } = await api.put("/api/generate_zapier_token?rewrite_existed=true");
      console.log(data)
      setToken(data.token);
    } catch (err) {
      console.error(err);
      alert(err.response.data.detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    isVisible && (
      <ConfirmationDialog
        isVisible={isVisible}
        onClose={onClose}
        title="Your Zapier Token"
        description={
          <div className="flex flex-col gap-4">
            <input
              type="text"
              readOnly
              value={token || ""}
              placeholder="No token yet. Press Generate button."
              className="border p-2 rounded"
            />
            <div className="flex gap-2">
              <button
                onClick={copyToClipboard}
                disabled={!token}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                Copy
              </button>
              <button
                onClick={() => generateToken(!!token)}
                disabled={loading}
                className="px-4 py-2 bg-blue-500 text-white rounded"
              >
                {token ? "Regenerate Token" : "Generate Zapier Token"}
              </button>
            </div>
          </div>
        }
        confirmLabel="Close"
        onConfirm={onClose}
      />
    )
  );
};

export default ZapierTokenDialog;
